export const comments = [
  {
    id: 1,
    animeId: 1,
    username: "追番小达人",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20icon%2C%20girl%20with%20pink%20hair%20and%20big%20eyes%2C%20simple%20circle%20composition%2C%20soft%20warm%20colors%2C%20clean%20background%2C%20chibi%20style%20portrait&width=100&height=100&seq=avatar-01&orientation=squarish",
    content: "苍兰诀的画风真的太美了！每一帧都可以截图当壁纸，剧情也超级感人，男女主的感情线写得太细腻了，强烈推荐！",
    rating: 5,
    date: "2026-06-28",
  },
  {
    id: 2,
    animeId: 1,
    username: "二次元老宅",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20icon%2C%20cool%20boy%20with%20dark%20hair%20and%20glasses%2C%20simple%20circle%20composition%2C%20warm%20neutral%20colors%2C%20clean%20background%2C%20chibi%20style%20portrait&width=100&height=100&seq=avatar-02&orientation=squarish",
    content: "配乐绝了！每次主题曲一响起来就起鸡皮疙瘩，国产动画能做到这个水准真的很了不起了。制作团队用心了！",
    rating: 5,
    date: "2026-06-25",
  },
  {
    id: 3,
    animeId: 1,
    username: "樱花下的猫",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20cat%20girl%20avatar%2C%20girl%20with%20cat%20ears%20and%20soft%20pastel%20colors%2C%20simple%20circle%20composition%2C%20pink%20and%20cream%20tones%2C%20clean%20background%2C%20kawaii%20chibi%20portrait&width=100&height=100&seq=avatar-03&orientation=squarish",
    content: "追了三个月的番终于完结了，虽然有点不舍但结局真的很圆满。期待第二季！另外特效真的很炫酷。",
    rating: 4,
    date: "2026-06-22",
  },
  {
    id: 4,
    animeId: 2,
    username: "动漫鉴赏师",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20serious%20male%20avatar%2C%20man%20with%20stern%20expression%20and%20samurai%20aesthetic%2C%20simple%20circle%20composition%2C%20dark%20warm%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-04&orientation=squarish",
    content: "鬼灭之刃的战斗场面制作绝对是顶级水准，ufotable的作画真的太强了。炭治郎的成长也很让人感动。",
    rating: 5,
    date: "2026-06-20",
  },
  {
    id: 5,
    animeId: 2,
    username: "深夜追番人",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20sleepy%20girl%20avatar%2C%20girl%20with%20bed%20hair%20and%20pajamas%2C%20simple%20circle%20composition%2C%20soft%20blue%20and%20white%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-05&orientation=squarish",
    content: "无限列车篇看哭了，大哥真的太帅了！炼狱杏寿郎yyds！每次重温都会被感动到，这才是真正的热血。",
    rating: 5,
    date: "2026-06-18",
  },
  {
    id: 6,
    animeId: 2,
    username: "热血少年",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20energetic%20boy%20avatar%2C%20boy%20with%20spiky%20hair%20and%20headband%2C%20simple%20circle%20composition%2C%20warm%20red%20and%20orange%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-06&orientation=squarish",
    content: "一口气看完的，根本停不下来！每个柱都太有魅力了，期待后续的剧情展开。打斗分镜帅炸！",
    rating: 5,
    date: "2026-06-15",
  },
  {
    id: 7,
    animeId: 5,
    username: "唐三的粉丝",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20blue%20haired%20boy%20avatar%2C%20cool%20expression%20with%20determined%20eyes%2C%20simple%20circle%20composition%2C%20cool%20blue%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-07&orientation=squarish",
    content: "从第一集追到现在，斗罗大陆真的是国产动画的里程碑之作。唐三的成长历程太精彩了，陪伴了我整个青春。",
    rating: 5,
    date: "2026-06-12",
  },
  {
    id: 8,
    animeId: 5,
    username: "武魂觉醒",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20purple%20haired%20girl%20avatar%2C%20mysterious%20and%20elegant%20look%2C%20simple%20circle%20composition%2C%20purple%20and%20silver%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-08&orientation=squarish",
    content: "263集每一集都很精彩，制作水平也是肉眼可见地在提升。小舞献祭那一集我哭了整整一晚上。",
    rating: 5,
    date: "2026-06-10",
  },
  {
    id: 9,
    animeId: 6,
    username: "阿尼亚赛高",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20pink%20haired%20little%20girl%20avatar%2C%20super%20cute%20expression%2C%20simple%20circle%20composition%2C%20pink%20and%20cream%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-09&orientation=squarish",
    content: "哇库哇库！阿尼亚太可爱了！每集都被治愈到，这个假家庭的温暖日常真的太好看了。期待剧场版！",
    rating: 5,
    date: "2026-06-08",
  },
  {
    id: 10,
    animeId: 6,
    username: "优雅的黄昏",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20suave%20man%20avatar%2C%20gentleman%20with%20suit%20and%20calm%20smile%2C%20simple%20circle%20composition%2C%20warm%20brown%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-10&orientation=squarish",
    content: "间谍过家家把严肃的间谍题材和温馨家庭喜剧结合得太完美了。约尔和洛伊德的互动每次都让我姨母笑。",
    rating: 4,
    date: "2026-06-05",
  },
  {
    id: 11,
    animeId: 11,
    username: "自由之翼",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20soldier%20avatar%2C%20serious%20expression%20with%20military%20aesthetic%2C%20simple%20circle%20composition%2C%20dark%20green%20and%20brown%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-11&orientation=squarish",
    content: "进击的巨人绝对是近十年最伟大的动画作品之一。从第一季到最终季，每个阶段的展开都让人震撼。谏山创是天才。",
    rating: 5,
    date: "2026-06-02",
  },
  {
    id: 12,
    animeId: 11,
    username: "调查兵团",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20blonde%20male%20avatar%2C%20brave%20and%20determined%20look%2C%20simple%20circle%20composition%2C%20golden%20and%20white%20tones%2C%20clean%20background%2C%20chibi%20portrait&width=100&height=100&seq=avatar-12&orientation=squarish",
    content: "最终季的动画制作虽然换了制作组，但MAPPA的实力也不容小觑。艾伦的变化让人唏嘘，战争从来就没有赢家。",
    rating: 5,
    date: "2026-05-30",
  },
];

export interface Comment {
  id: number;
  animeId: number;
  username: string;
  avatar: string;
  content: string;
  rating: number;
  date: string;
}